import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class InputErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    const parentGroup = control?.parent;

    const isControlInvalid =
      control?.invalid && (control?.dirty || control?.touched);
    const isParentInvalid =
      parentGroup?.invalid &&
      (parentGroup?.dirty || parentGroup?.touched || control?.touched);

    return !!(isControlInvalid || isParentInvalid);
  }
}
